import type { Permission } from './roles';

/**
 * Стартовый раздел после входа.
 *
 * Общий вход на доску выпуска встречал водителя, медработника и механика экраном
 * «Недостаточно прав»: доска требует `release:read`, которого у них нет. Поэтому
 * стартовая страница выбирается по правам, а не задаётся одна для всех.
 *
 * Порядок значим — берётся первое совпадение, поэтому специальные кабинеты
 * (медосмотр, техосмотр, «Моя смена») стоят раньше общих списков.
 */
const LANDING_BY_PERMISSION: readonly { permission: Permission; path: string }[] = [
  { permission: 'release:read', path: '/board' },
  { permission: 'medical:write', path: '/medic' },
  { permission: 'technical:write', path: '/mechanic' },
  { permission: 'assignment:respond', path: '/driver' },
  { permission: 'shift:read', path: '/shifts' },
  { permission: 'user:manage', path: '/users' },
];

/** Раздел справки открыт всем авторизованным — годится как последний рубеж. */
export const FALLBACK_LANDING = '/guide';

/**
 * Куда отправить пользователя после входа.
 * @param has проверка права: `can` из контекста авторизации.
 */
export function landingPath(has: (permission: Permission) => boolean): string {
  return LANDING_BY_PERMISSION.find((entry) => has(entry.permission))?.path ?? FALLBACK_LANDING;
}
